(() => {
  if (customElements.get('recently-viewed')) {
    return;
  }

  const ProductsCarousel = customElements.get('products-carousel');

  // component-products-carousel.js defines the base class. Both files are
  // deferred, so if it has not registered yet there is nothing to extend and
  // `extends undefined` would throw a TypeError at parse time, taking the whole
  // script down. Bail out quietly instead.
  if (!ProductsCarousel) {
    console.warn('[recently-viewed] products-carousel is not defined; skipping.');
    return;
  }

  class RecentlyViewed extends ProductsCarousel {
    constructor() {
      super();

      this.productHandle = this.dataset.productHandle;

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.fetchRecentProducts();
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }

    fetchRecentProducts() {
      const handles = localStorage.getItem('recently-viewed');

      if (!handles) {
        this.classList.add('hidden');
        return;
      }

      const handlesToFetch = handles
        .split(',')
        .map(handle => handle.trim())
        .filter(handle => handle && handle !== this.productHandle);

      if (handlesToFetch.length === 0) {
        this.classList.add('hidden');
        return;
      }

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      // A single failed handle (deleted or unpublished product) must not reject
      // the whole batch, so each fetch resolves to null instead of throwing.
      const fetchProductsByHandle = handlesToFetch.map(handle =>
        fetch(`${root}products/${handle}?view=card`)
          .then(response => (response.ok ? response.text() : null))
          .catch(() => null)
      );

      Promise.all(fetchProductsByHandle)
        .then(results => {
          const wrapper = this.querySelector('.products-carousel__slider .swiper-wrapper');

          if (!wrapper) return;

          // Promise.all resolves to an ARRAY. Parsing it directly stringified
          // the array (comma-joined), so parse each response separately.
          results.filter(Boolean).forEach(html => {
            new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelectorAll('product-card')
              .forEach(product => {
                const productHtmlWrapper = document.createElement('DIV');

                productHtmlWrapper.classList.add('products-carousel__slide', 'swiper-slide');
                productHtmlWrapper.appendChild(product);
                wrapper.append(productHtmlWrapper);
              });
          });

          if (!wrapper.children.length) {
            this.classList.add('hidden');
            return;
          }

          // Build the slider once, after every card is in the DOM, and scope it
          // to this element. The previous code called `new Swiper` inside the
          // loop with a global selector, so it re-initialised per product and
          // could bind to a different carousel on the page.
          if (this.swiper) {
            this.swiper.update();
          } else {
            this.initSwiper();
          }
        })
        .catch(() => {
          this.classList.add('hidden');
        });
    }
  }

  customElements.define('recently-viewed', RecentlyViewed);
})();
